module.exports = __webpack_public_path__ + "img/01.e66bffa9.png";